<template>
  <div>
    <!-- Modal Structure -->
    <div id="modal1" class="modal">
      <div class="modal-content">
        <div class="flow-text">
          <h5>Fletes escaneados</h5>
        </div>
        <ul class="collapsible">
          <li v-for="(cartons, guia) in numeros_guias" :key="guia">
            <div class="collapsible-header">
              <i class="mdi mdi-truck-delivery"></i>
              <span class="">
                <b>{{ guia }}</b>
              </span>
              <span class="badge">
                <i class="mdi mdi-package-variant"></i>
                {{ cartons.length }}
              </span>
            </div>
            <div class="collapsible-body">
              <ul class="collection">
                <li v-for="carton in cartons" :key="carton.no_carton" class="collection-item">
                  <span>
                    {{ carton.dsforderid }}-{{ carton.ccmasterid }}-{{
                    carton.jobpart
                    }}-{{ carton.shipviaid }}-{{ carton.no_carton }}-{{
                    carton.total_cartons
                    }}
                  </span>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
      <div class="modal-footer">
        <a class="modal-close waves-effect waves-green btn-flat">Cerrar</a>
      </div>
    </div>
    <form class="" @submit="procesarCartones($event)">
      <div class="row">
        <div class="col s12 input-field">
          <label class="active" for="code-input">CÓDIGO DEL PAQUETE</label>
          <input type="text" @focus="$forceUpdate()" @keypress.enter="procesarCartones($event)" style="
              font-size: 1rem !important;
              margin: 0px;

              text-align: center;
            " placeholder="Intenta escanear algunas etiquetas ó # de guía" class="" required v-model="QRcarton"
            id="code-input" name="code-input" />
        </div>
      </div>
    </form>
    <div class="row">
      <DataTable :delete_rows="true" :responsive="false" :data="cartons_local" :indexes="Object.keys(cartons_local)"
        :rows="Object.values(cartons_local)" sort_key="ccmasterid" :columns="{
          ccmasterid: 'Trabajo',
          dsforderid: 'Orden de DSF',
          jobpart: 'Parte',
          no_carton: '# Carton',
          qtythiscarton:'Piezas',
          //shipviaid: 'Shipvia',
          shipviadesc: 'Lugar de entrega',
          paqueteria_numero_rastreo: '# de guía',
        }"></DataTable>
      <div class="row">
        <a @click="limpiarEscaneos" class="btn-flat center">
          <i class="mdi mdi-delete"></i>
          Limpiar tabla
        </a>
        <!-- Modal Trigger -->
        <a v-show="total_guias" class="btn-flat modal-trigger" href="#modal1">
          <i class="mdi mdi-truck-delivery"></i>
          Ver {{ total_guias }} flete(s) </a>
      </div>
    </div>
  </div>
</template>

<script>
  import Carton from "../../../firebase_models/Carton.js";
  import M from "materialize-css";
  import DataTable from "../../datatable";
  export default {
    components: { DataTable },
    props: {
      db: Object,
      cartons: Object,
    },
    created() {
      console.log("qr-escaner created");
      document.addEventListener("limpiarEscaneos", this.limpiarEscaneos);
      document.addEventListener("shipvias", (e) => {
        this.shipvias = e.detail;
        console.log("shipvias_evt", this.shipvias);
      });
      this.focusCodeInput();
      setTimeout(M.AutoInit, 0);
    },
    data() {
      let local_almacen = localStorage.getItem("almacen-shipvia");
      if (local_almacen) {
        local_almacen = JSON.parse(local_almacen);
      }
      return {
        almacen_shipvia: local_almacen,
        cartons_local: this.cartons,
        codeInput: undefined,
        shipvias: window.shipvias,
        QRcarton: "",
      };
    },
    computed: {
      total_guias() {
        return Object.keys(this.numeros_guias).length;
      },
      numeros_guias() {
        let guias = {},
          sin_guia = [],
          cartons = this.cartons,
          carton_values = Object.values(cartons);
        carton_values.forEach((carton) => {
          if (carton["paqueteria_numero_rastreo"])
            if (guias[carton["paqueteria_numero_rastreo"]])
              guias[carton["paqueteria_numero_rastreo"]].push(carton);
            else guias[carton["paqueteria_numero_rastreo"]] = [carton];
          else sin_guia.push(carton);
        });
        if (sin_guia.length) guias["Sin asignar"] = sin_guia;
        return guias;
      },
      shipvias_map() {
        let mapa = {};
        if (this.shipvias)
          this.shipvias.forEach((via) => {
            mapa[via.syshipviaid*1] = via.sydescription;
          });
        return mapa;
      },
    },
    methods: {
      getShipVia(id) {
        let res = window.shipvias.filter(x => x.syshipviaid === id)
        if (res.length) return res[0].sydescription
        return [0];
      },

      limpiarEscaneos() {
        this.cartons_local = {};
        this.$forceUpdate();
        this.$emit("limpiar_cartons");
      },

      procesarCartones($e) {
        $e.preventDefault();
        if (!this.QRcarton) return;
        this.QRcarton.split(/[\n ]/).forEach((token) => {
          this.escaneo_carton(token);
        });
        this.$emit("cartons", this.cartons_local);
        window.scrollTo(0, document.body.scrollHeight);
      },
      escaneo_carton(token) {
        if (token.length < 1) return;
        let regex = Carton.regex;
        let carton = {};
        let id = Carton.normalizeId(token);

        console.log(token);

        // Nomenclatura de codigo
        // {$dsforderid}-{$ccmasterid}-{$jobpart}-{$shipviaid}-{$no_carton}-{$total_carton}
        try {
          if (regex.test(id)) {
            carton = Carton.parse(id);

            carton.shipviadesc =
              this.shipvias_map[carton.shipviaid*1] || "No registrada";
            // Solo se muestra esta alerta cuando no se encuentra en las rutas de /chofer y /taller
            if (location.pathname==='/almacen') {
              // comprueba que el shipviaid sea diferente del almacen_shipvia.shipvia.syshipviaid
              if ((carton.shipviaid != this.almacen_shipvia.shipvia.syshipviaid)
                && !confirm(
                  `El shipvia ${this.shipvias_map[carton.shipviaid]} del paquete ${token} no coincide con la via ${this.shipvias_map[this.almacen_shipvia.shipvia.syshipviaid]} de este almacen. ¿Deseas conservar el paquete?`
                )
              ) {
                this.QRcarton = "";
                return;
              }
            }

            if (!this.cartons_local[id]) this.cartons_local[id] = carton;
            // Ya existe en la lista
            else
              M.toast({
                html: "Ya existe este paquete en la lista",
                classes: "teal",
              });
          } else {
            Carton.docsRefsFromNumeroRastreo(this.db, token).then((cartons) => {
              Object.assign(this.cartons_local, cartons);
              this.$forceUpdate();
              this.$emit("cartons", this.cartons_local);
            });
          }
        } catch (error) {
          throw new Error(error);
        }
        this.QRcarton = undefined;
      },
      focusCodeInput() {
        setTimeout(() => {
          let codeInput = document.querySelector("#code-input");
          codeInput.focus();
          console.log("scanner focus");
        }, 10);
      },
    },
  };
</script>